<template>
<div class="container-medium m-auto">
    <div class="mx-5" v-loading="loading">
        <terms-form
            :corporation="corporation"
            :type="type"
            :terms="terms"
            @load="load"
            @terms-accepted="callback"
        >
            <template slot="button">{{ $l10n.__('j\'accepte les conditions générales') | capitalize }}</template>
        </terms-form>
    </div>
</div>
</template>
<script>

import TermsForm from 'vcomponents/sellsyaccountmanager/TermsForm.vue';

export default {
    props: {
        corporation: {
            type: String,
            required: true
        },
        terms: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        redirect: {
            type: String,
            default: '/home'
        }
    },
    data() {
        return {
            terms_checked: false,
            loading: false,
        }
    },
    methods: {
        load(load) { this.loading = load; },
        callback() { 
            this.load(true); 
            window.location.href = this.redirect; 
        }
    },

    components: {
        TermsForm,
    }
}
</script>